import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';

export interface DividerProps {
  type?: 'horizontal' | 'vertical';
}

const HorizontalDivider = styled.div`
  background-color: ${theme.dime.colors.border.static};
  height: 1px;
  width: 100%;
  margin: ${theme.dime.spacing.m} 0;
`;

const VerticalDivider = styled.div`
  background-color: ${theme.dime.colors.border.static};
  width: 1px;
  height: auto;
  align-self: stretch;
  margin: 0 ${theme.dime.spacing.m};
`;

export const Divider: React.FC<DividerProps> = ({ type = 'horizontal' }) => {
  return type === 'horizontal' ? <HorizontalDivider /> : <VerticalDivider />;
};
